import axios from "axios"
import querystring from "querystring"

const instance = axios.create({
    timeout: 5000
})

instance.interceptors.request.use(
    config => {
        if(config.method === 'post' && !(config.data instanceof FormData)){
            config.data = querystring.stringify(config.data)
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {
        return response.status === 200? Promise.resolve(response): Promise.reject(response)
    },
    error => {

    }
)

export default instance